export enum VEHICLE_COLORS {
  Beige = 'Beige',
  Black = 'Black',
  Blue = 'Blue',
  Brown = 'Brown',
  Gray = 'Gray',
  Green = 'Green',
  Orange = 'Orange',
  Red = 'Red',
  Silver = 'Silver',
  White = 'White',
  Purple = 'Purple',
  Yellow = 'Yellow',
}

export const VEHICLE_COLOR_HEX: Record<VEHICLE_COLORS, string> = {
  [VEHICLE_COLORS.Black]: '#000000',
  [VEHICLE_COLORS.Purple]: '#720CB5',
  [VEHICLE_COLORS.Blue]: '#005292',
  [VEHICLE_COLORS.Red]: '#CC1D3A',
  [VEHICLE_COLORS.Brown]: '#885F37',
  [VEHICLE_COLORS.Silver]: '#CCCCCC',
  [VEHICLE_COLORS.Green]: '#017C39',
  [VEHICLE_COLORS.Beige]: '#D9D4AA',
  [VEHICLE_COLORS.Gray]: '#808080',
  [VEHICLE_COLORS.White]: '#FFFFFF',
  [VEHICLE_COLORS.Orange]: '#F7931E',
  [VEHICLE_COLORS.Yellow]: '#FFF200',
};

export const LIGHT_VEHICLE_COLORS: Set<string> = new Set([
  VEHICLE_COLORS.Silver,
  VEHICLE_COLORS.Beige,
  VEHICLE_COLORS.White,
  VEHICLE_COLORS.Yellow,
]);
